import React from "react";
import { Link } from "react-router-dom";
import Page from '../types/Page';

const ChildNav = ({ children } : {children: Page[]}) => {
  return (
    <>
      Read More:
      { children.map((p, i) => <Link key={p.id} to={`/page/${p.slug}`}>{i !== 0 ? ' | ' : ''} {p.title} </Link>)}
    </>
  );
};

export default ChildNav; 